export default {
  path: '/appManage',
  name: 'appManage',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '应用管理',
  },
  children: [
    {
      path: 'devRecord',
      name: 'DevRecord',
      component: () => import('../../views/DevManage/DevRecord'),
      meta: { title: '设备档案', keepAlive: false }
    },
    {
      path: 'devGroup',
      name: 'DevGroup',
      component: () => import('../../views/DevManage/DevGroup'),
      meta: { title: '设备分组', keepAlive: false }
    },
    {
      path: 'devAuth',
      name: 'DevAuth',
      component: () => import('../../views/DevManage/DevAuth'),
      meta: { title: '设备授权', keepAlive: false }
    },
    {
      path: 'devWechat',
      name: 'DevWechat',
      component: () => import('../../views/DevManage/DevWechat'),
      meta: { title: '设备公众号', keepAlive: false }
    },
    {
      path: 'devChannel',
      name: 'DevChannel',
      component: () => import('../../views/DevManage/DevChannel'),
      meta: { title: '设备渠道管理', keepAlive: false }
    },
    {
      path: 'operatorReportIndex',
      name: 'OperatorReportIndex',
      component: () => import('../../views/DevManage/OperatorReportIndex'),
      meta: { title: '设备业务报表（运营）', keepAlive: false }
    },
    {
      path: 'agentReportIndex',
      name: 'AgentReportIndex',
      component: () => import('../../views/DevManage/AgentReportIndex'),
      meta: { title: '设备业务报表（用户）', keepAlive: false }
    },
  ]
}